export default __webpack_public_path__ + "static/media/fastagCard.192eb108.png";